module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chap-no1"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("WHAT IS QUILTING?")]), _vm._v(" "), _c('div', {
    staticClass: "img_container1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0007-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionc"
  }, [_vm._v("Snowflake Placemat (see "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#page_78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 78")]), _vm._v(").")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0007-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "captionc"
  }, [_vm._v("Humbug Hexie Quilt (see "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#page_90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 90")]), _vm._v(").")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Quilting is simply the method of stitching three layers of fabric together. This ‘sandwich’ consists of top and backing fabrics, with a layer of wadding/batting in the centre. The top fabric can be plain, patterned or patchworked. The wadding/batting comes in many thicknesses (referred to as the ‘loft’), and can be made from natural or synthetic fibres. More about patchwork and padding later; for now let’s take a look at some of the different ways of quilting your project. Remember – that project doesn’t have to be a full-sized bed quilt; as a beginner, you may prefer to start with something smaller, such as a placemat (see right) or pillowcase (as seen on "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#page_70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 70")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The appearance of your stitches can be as much a part of your quilt as the colour and pattern of your fabric. Choose contrasting thread to make the stitched design really stand out, or make the stitches less noticeable by ‘stitching in the ditch’ (sewing over an existing seam) using clear or co-ordinating thread.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In terms of what stitches to use, it is your choice whether to free-motion embroider your quilting design, either freehand or by following existing designs and templates; hand- or machine-sew lines or squares (known as ‘cross-hatching’) across your fabric; or even tie the layers together with knotted thread, then either make bows or add buttons to embellish.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you’re using a patterned fabric, try outlining elements of the pattern with stitching (which you can see on "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#page_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 45")]), _vm._v("). If you want a uniform, professional finish to your quilt, or if you find the prospect of quilting a large project a little daunting, take your quilt to a longarm quilting expert – they will have specific machines, a catalogue of designs and a wealth of knowledge that they will share with you!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Covering your work in dense stitches will give a firmer feel to your quilt and is an excellent choice for items that will be laundered, as it will help to keep the layers of fabric from shifting. A looser quilting stitch will create a softer feel to your quilted item. However, it is worth taking note of your wadding/ batting manufacturer’s guidance on how far apart your stitches should be.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "centerb"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Important note")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("As fabric for quilting and patching is mostly measured and cut using the imperial system, I have used this throughout the book. The imperial measurement is always accompanied by the equivalent metric measurement in parentheses.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27d8eb1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Frontmatter04.vue
// module id = 81
// module chunks = 0